import { Button } from "@sidelinesports/fan-design-system";
import { EditIcon } from "@sidelinesports/icons";
import { Link } from "react-router";
import { useCurrentGameQuery } from "../../hooks/use-current-game.ts";

export const ChangePicksButton = () => {
  const gameQuery = useCurrentGameQuery();

  if (gameQuery.isPending || gameQuery.isError) {
    return null;
  }

  const game = gameQuery.data;

  if (game.status !== "about_to_start") {
    return null;
  }

  return (
    <Button
      as={Link}
      to={`/games/${game.id}/pick-your-players`}
      variant="action"
      size="lg"
      icon={<EditIcon />}
    >
      Change Picks
    </Button>
  );
};
